module.exports = __webpack_public_path__ + "static/media/menuCorporateLunch.af8203cc.jpg";